import React from "react";
import { Container, Col, Row } from "reactstrap";
import ListItem from "../UI-Card/ListItem";
import PortfolioNav from "../headerComponent/portfolioNav";
import { geometryArtwork, logos, posters } from "../../data/images";

const Graphics = () => {
  return (
    <Container className="photo-gallery">
      <Row>
        <Col xs="2" md="3" lg="4" />
        <Col xs="8" md="6" lg="4">
          <PortfolioNav />
        </Col>
        <Col xs="2" md="3" lg="4" />
      </Row>
      <Row>
        <Col>
          <h1>Graphic Elements</h1>
          <p>
            Here&apos;s some of my design works I have done while I was studying
            including logos, brochures, posters, and more.
          </p>
        </Col>
      </Row>
      <h2 className="mt-5">Logos</h2>
      <Row className="card-gallery">
        <Col className="four-columns">
          {logos.map(obj => (
            <ListItem key={obj.id} imageInfo={obj} />
          ))}
        </Col>
      </Row>
      <h2 className="mt-5">Artwork</h2>
      <Row className="card-gallery">
        <Col className="three-columns">
          {geometryArtwork.map(obj => (
            <ListItem key={obj.id} imageInfo={obj} />
          ))}
        </Col>
      </Row>
      <h2 className="mt-5">Posters</h2>
      <Row className="card-gallery">
        <Col className="two-columns">
          {posters.map(obj => (
            <ListItem key={obj.id} imageInfo={obj} />
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default Graphics;
